export function noop() { }
export var EndOfLineSequence;
(function (EndOfLineSequence) {
    EndOfLineSequence["LF"] = "\n";
    EndOfLineSequence["CRLF"] = "\r\n";
})(EndOfLineSequence || (EndOfLineSequence = {}));
class ValidationError extends Error {
    constructor() {
        super(...arguments);
        this.name = "Validation Failed";
    }
}
class NoopError extends Error {
    constructor() {
        super(...arguments);
        this.name = "No-op Encountered";
    }
}
class InvalidOperationError extends Error {
    constructor() {
        super(...arguments);
        this.name = "Invalid Operation Encountered";
    }
}
class InvalidOperationOrderError extends Error {
    constructor() {
        super(...arguments);
        this.name = "Invalid Order of Operations Encountered";
    }
}
class InvalidEventError extends Error {
    constructor() {
        super(...arguments);
        this.name = "Invalid Event Encountered";
    }
}
class DatabaseTransactionError extends Error {
    constructor() {
        super(...arguments);
        this.name = "Transaction Failed";
    }
}
export function validateInteger(n, err) {
    if (!Number.isInteger(n)) {
        throw new ValidationError(err || "Expected an integer value");
    }
}
export function validateNonNegativeInteger(n, err) {
    validateInteger(n, err);
    if (n < 0) {
        throw new ValidationError(err || "Expected a non-negative integer value");
    }
}
export function validateString(n, err) {
    if (typeof n !== "string") {
        throw new ValidationError(err || "Expected a string value");
    }
}
export function validateEquality(first, second, err) {
    if (first !== second) {
        throw new ValidationError(err || `Expected ${first.toString()} to be equal to ${second.toString()}.`);
    }
}
export function validateInEquality(first, second, err) {
    if (first === second) {
        throw new ValidationError(err ||
            `Expected ${first.toString()} to not be equal to ${second.toString()}.`);
    }
}
export function validateLessOrEqual(first, second, err) {
    if (first > second) {
        throw new ValidationError(err || `Expected ${first} to be less than or equal to ${second}.`);
    }
}
export function validateGreater(first, second, err) {
    if (first <= second) {
        throw new ValidationError(err || `Expected ${first} to be greater than ${second}.`);
    }
}
export function validateTruth(arg, err) {
    if (arg == null || arg === false) {
        throw new ValidationError(err || "Expected a Truth value");
    }
}
export function validateFalse(arg, err) {
    if (arg === true) {
        throw new ValidationError(err || "Expected a False value");
    }
}
export function shouldNotGetCalled(err) {
    throw new NoopError(err || "This method should not get called or has no operation to perform");
}
export function shouldNotBeListenedTo(event, err) {
    throw new InvalidEventError(err || `Unknown event ${event} to add/remove listener for given object`);
}
export function shouldNotBeComposedOrApplied(err) {
    throw new InvalidOperationOrderError(err ||
        "Invalid order of operation recieved that cannot be composed or applied");
}
export function onFailedDatabaseTransaction(err) {
    throw new DatabaseTransactionError(err || "Transaction Failure!");
}
export function onInvalidOperationRecieve(err) {
    throw new InvalidOperationError(err || "Invalid operation recieved!");
}
export function rgbToHex(red, blue, green) {
    const depth = [red, blue, green].map((color) => Math.round(255 * color)
        .toString(16)
        .padStart(2, "0"));
    return ["#", ...depth].join("");
}
export function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        return [0, 0, 0];
    }
    return [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
    ];
}
function hueToRgb(degree, percentage1, percentage2) {
    if (degree < 0) {
        degree += 1;
    }
    if (degree > 1) {
        degree -= 1;
    }
    if (6 * degree < 1) {
        return percentage1 + (percentage2 - percentage1) * 6 * degree;
    }
    if (2 * degree < 1) {
        return percentage2;
    }
    if (3 * degree < 2) {
        return percentage1 + (percentage2 - percentage1) * 6 * (2 / 3 - degree);
    }
    return percentage1;
}
export function hslToHex(hue, saturation, lightness) {
    if (saturation === 0) {
        return rgbToHex(lightness, lightness, lightness);
    }
    const percentage2 = lightness < 0.5
        ? lightness * (1 + saturation)
        : lightness + saturation - saturation * lightness;
    const percentage1 = 2 * lightness - percentage2;
    return rgbToHex(hueToRgb(hue + 1 / 3, percentage1, percentage2), hueToRgb(hue, percentage1, percentage2), hueToRgb(hue - 1 / 3, percentage1, percentage2));
}
export function colorFromUserId(userId) {
    let a = 1;
    for (let i = 0; i < userId.length; i++) {
        a = (17 * (a + userId.charCodeAt(i))) % 360;
    }
    const hue = a / 360;
    return hslToHex(hue, 1, 0.75);
}
export function capitalizeFirstLetter(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}
